import {FC, useState} from "react";
import {Button, Card, Col, Row} from "react-bootstrap";
import {useNavigate} from "react-router";
import {useFormikContext} from "formik";
import {SimpleConfirmModal} from "@components/panel";

interface FormFooterBlockProps {
    cancelUrl?: string;
    descText?: string;
    onDelete?: () => any;
}

const FormPageFooter: FC<FormFooterBlockProps> = ({cancelUrl, descText, onDelete}) => {

    const navigate = useNavigate();
    const back = () => navigate(cancelUrl || '', { replace: true });
    const [showConfirm, setShowConfirm] = useState(false);

    const {
        isValid,
        isSubmitting
    } = useFormikContext();

    return (
        <>
            <Card>
                <Card.Body>
                    <Row className="flex-between-center">
                        <Col md>
                            <h5 className="mb-2 mb-md-0">{descText}</h5>
                            {onDelete && (
                                <Button variant="danger" type="button" onClick={() => setShowConfirm(true)} className="me-2 mb-1">
                                    Удалить
                                </Button>
                            )}
                        </Col>
                        <Col xs="auto">
                            {cancelUrl && (
                                <Button
                                    variant="link"
                                    className="text-secondary fw-medium p-0 me-3"
                                    type="button"
                                    onClick={back}
                                >
                                    Отменить
                                </Button>
                            )}
                            <Button variant="primary" type="submit" disabled={!isValid && !isSubmitting}>
                                Сохранить
                            </Button>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
            {onDelete && (
                <SimpleConfirmModal
                    isOpen={showConfirm}
                    toggle={() => setShowConfirm(false)}
                    title="Подтверждение удаления"
                    bodyText="Вы уверены, что хотите удалить?"
                    onConfirm={onDelete}
                    confirmText="Удалить"
                    cancelText="Отмена"
                    variant="danger"
                />
            )}
        </>
    )
}

export default FormPageFooter;
